import { sanitize } from 'dompurify'

export const sanitizeEditorsOutputContent = (description?: string) => {
  if (!description) {
    return ''
  }

  const clean = sanitize(description, {
    WHOLE_DOCUMENT: true,
    FORBID_TAGS: ['title'],
    ADD_TAGS: ['link', 'style', 'iframe', 'img'],
    ADD_ATTR: [
      'style',
      'class',
      'width',
      'border',
      'cellpadding',
      'cellspacing',
      'align',
      'valign',
      'bgcolor',
      'href',
      'rel',
      'type',
      'target',
      'role',
      'src',
      'alt',
      'title',
      'font-size',
      'frameborder',
    ],
  })

  const styleTagInitialIndex = clean.lastIndexOf('<style>')
  const styleTagFinalIndex = clean.indexOf('</style>')

  let formatted =
    clean.slice(0, styleTagInitialIndex) +
    clean
      .slice(styleTagInitialIndex, styleTagFinalIndex)
      .replace(/body/g, '.bee-page-container') +
    clean.slice(styleTagFinalIndex)

  formatted = formatted
    .replace(/<html>/g, '')
    .replace(/<\/html>/g, '')
    .replace(/^\s+|\s+$|\s+(?=\s)/g, '')
    .replace(/<p>&nbsp;<\/p>/g, '')
    .replace(/&nbsp;/g, '')

  return formatted
}

const exports = {
  sanitizeEditorsOutputContent,
}

export default exports
